import React from 'react';

const BOOKING_URL = process.env.REACT_APP_BOOKING_URL || 'https://agenda.filtrosyaceitesjm.com/login';

const TemplateModern = ({ data, config }) => {
  const activeServices = Array.isArray(data?.services) && data.services.length > 0
    ? config.services.filter(s => data.services.includes(s.id))
    : config.services.slice(0, 6);

  const primary = data.brand_color_primary || '#1e293b';
  const secondary = data.brand_color_secondary || '#7c3aed';

  // Hex con opacidad para fondos suaves

  return (
    <div className="min-h-screen bg-gray-900 text-white font-sans">
      {/* Hero Section */}
      <header
        className="relative py-32 px-6 overflow-hidden flex flex-col items-center justify-center text-center"
        style={{
          backgroundImage: `url(${data.hero_image_url || config.images[0].url})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 z-0" style={{ backgroundColor: primary, opacity: 0.82 }}></div>
        <div className="relative z-10 max-w-4xl mx-auto">
          <h1
            className="text-5xl md:text-7xl font-black mb-6 tracking-tight"
            style={{
              backgroundImage: `linear-gradient(to right, ${secondary}, #ffffff)`,
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent'
            }}
          >
            {data.name || config.defaultTitle}
          </h1>
          <p className="text-xl md:text-2xl text-gray-300 mb-10 max-w-2xl mx-auto">
            {config.defaultDescription}
          </p>
          <button
            className="text-white px-8 py-4 rounded-full font-bold text-lg transition-opacity hover:opacity-90 shadow-lg"
            style={{ backgroundColor: secondary }}
            onClick={() => { window.location.href = `${data.booking_url || BOOKING_URL}?workshopId=${data.id}&niche=${data.niche}`; }}
          >
            Agendar Cita Ahora
          </button>
        </div>
      </header>

      {/* Services Section */}
      <section className="py-20 px-6 relative overflow-hidden" style={{ backgroundColor: '#050810' }}>
        {/* Mesh background */}
        <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: `radial-gradient(ellipse at 20% 50%, ${secondary}18 0%, transparent 60%), radial-gradient(ellipse at 80% 20%, ${primary}30 0%, transparent 50%)`
        }}></div>

        <div className="relative max-w-6xl mx-auto">
          <div className="flex items-center gap-4 mb-12">
            <div className="h-px bg-gray-800 flex-1"></div>
            <h2 className="text-3xl font-bold text-center tracking-wide uppercase text-gray-400">Servicios</h2>
            <div className="h-px bg-gray-800 flex-1"></div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {activeServices.map((service, index) => (
              <div
                key={index}
                className="relative p-7 rounded-2xl group transition-all duration-300"
                style={{
                  background: 'rgba(255,255,255,0.04)',
                  backdropFilter: 'blur(16px)',
                  WebkitBackdropFilter: 'blur(16px)',
                  border: `1px solid rgba(255,255,255,0.08)`,
                  boxShadow: '0 8px 32px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.06)',
                }}
              >
                {/* Reflejo de luz superior */}
                <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{ background: 'linear-gradient(135deg, rgba(255,255,255,0.10) 0%, transparent 45%)' }}></div>
                {/* Linea top con color de marca */}
                <div className="absolute top-0 left-6 right-6 h-px rounded-full" style={{ background: `linear-gradient(to right, transparent, ${secondary}80, transparent)` }}></div>

                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-5 text-2xl"
                  style={{
                    background: `linear-gradient(135deg, ${secondary}25, ${secondary}10)`,
                    border: `1px solid ${secondary}30`,
                  }}
                >
                  {service.icon}
                </div>
                <h3 className="text-lg font-bold capitalize mb-2 text-white">{service.title}</h3>
                <p className="text-gray-400 text-sm leading-relaxed">{service.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TemplateModern;
